import { MobileCommForm } from "../MobileCommForm";
import { MobileCommFormGroupByTable } from "../MobileCommFormGroupByTable";
import { MobileCommFormGroupByVendor } from "../MobileCommFormGroupByVendor";
import { Layout, LayoutHeader, Splitter, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFormGroupList extends Layout {
    layoutFormGroupById: MobileCommForm;
    layoutFormGroupByTable: MobileCommFormGroupByTable;
    layoutFormGroupByVendor: MobileCommFormGroupByVendor;
    layoutheaderFormGroupList: LayoutHeader;
    splitterFormGroupList: Splitter;
    textboxDateRange: Textbox;
}
